import React from 'react';
import { string, func, object, oneOfType, number } from 'prop-types';
import { Y500 } from '@assets/colors';
import { noop } from '@ajaibid/utils';

const IconInfo = ({ color, onClick, size, style, ...rest }) => (
  <svg
    style={style}
    width={size}
    height={size}
    onClick={onClick}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="infoIcon"
    {...rest}
  >
    <circle cx="8" cy="8" r="5" stroke={color} strokeWidth="1.5" />
    <circle cx="8" cy="5.75" r="0.75" fill={color} />
    <path d="M8 8V11" stroke={color} strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);
IconInfo.propTypes = {
  color: string,
  onClick: func,
  size: oneOfType([string, number]),
  style: object,
};

IconInfo.defaultProps = {
  color: Y500,
  onClick: noop,
  size: 16,
  style: {},
};

export default IconInfo;
